import { render, staticRenderFns } from "./CommandDetail.vue?vue&type=template&id=768eaffa&scoped=true&"
import script from "./CommandDetail.vue?vue&type=script&lang=js&"
export * from "./CommandDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommandDetail.vue?vue&type=style&index=0&id=768eaffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768eaffa",
  null
  
)

export default component.exports